<template>
  <div class="flex items-center justify-between rounded p-2 text-gray-600 dark:text-gray-300 bg-white dark:bg-gray-900">
    <p>
      <span class="font-semibold pr-1">
        {{ association.target.title }}
      </span>

      <!-- <span class="opacity-70">|</span> -->

      <add-on-price
        :price-label="association.target.priceLabel"
        :price-from="association.target.priceFrom"
        :price-has-additional-taxes="association.target.priceHasAdditionalTaxes"
        :has-discount="association.discountAmount > 0"
        :discounted-price="discountedPrice"
      />
    </p>

    <div>
      <o-button variant="primary" size="xs" @click="onAddService">
        {{ $t('general.add') }}
      </o-button>
    </div>
  </div>
</template>

<script>
import AddOnPrice from './AddOnPrice'
import { ServiceAssociation } from '@/_api/models/serviceAssociation'

export default {
  components: {
    AddOnPrice,
  },
  props: {
    association: {
      type: Object,
      required: true,
    },
  },
  computed: {
    discountedPrice () {
      return ServiceAssociation.formatDiscountedPrice(
        this.association,
        this.$auth.info.location.currencySymbol,
      )
    },
  },
  methods: {
    onAddService () {
      this.$emit('add', this.association)
    },
  },
}
</script>
